module.exports = __webpack_public_path__ + "img/loginBGImg.cbea0e79.png";